"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpExceptionCodes = void 0;
var HttpExceptionCodes;
(function (HttpExceptionCodes) {
    HttpExceptionCodes["BadRequest"] = "BAD_REQUEST";
    HttpExceptionCodes["Unauthorized"] = "UNAUTHORIZED";
    HttpExceptionCodes["Forbidden"] = "FORBIDDEN";
    HttpExceptionCodes["NotFound"] = "NOT_FOUND";
    HttpExceptionCodes["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    HttpExceptionCodes["ValidationError"] = "VALIDATION_ERROR";
})(HttpExceptionCodes = exports.HttpExceptionCodes || (exports.HttpExceptionCodes = {}));
